export default __webpack_public_path__ + "8e72fb2394a4994d96f530765c052c45.png";